import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  MANAGE_SUBS_DELETE_MANAGE_SUBS_BEGIN,
  MANAGE_SUBS_DELETE_MANAGE_SUBS_SUCCESS,
  MANAGE_SUBS_DELETE_MANAGE_SUBS_FAILURE,
  MANAGE_SUBS_DELETE_MANAGE_SUBS_DISMISS_ERROR,
} from './constants';
import { API_REQUEST_URL } from '../../../common/apiConfig';

export function deleteManageSubs(args = {}) {
  return (dispatch, getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_DELETE_MANAGE_SUBS_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
     
      const doRequest = axios.delete(`${API_REQUEST_URL}/deleteManageSubs`, {
        headers: {
          'Authorization': token,
        },
        data: args,
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: MANAGE_SUBS_DELETE_MANAGE_SUBS_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_DELETE_MANAGE_SUBS_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteManageSubsError() {
  return {
    type: MANAGE_SUBS_DELETE_MANAGE_SUBS_DISMISS_ERROR,
  };
}

export function useDeleteManageSubs() {
  const dispatch = useDispatch();

  const { deleteManageSubsPending, deleteManageSubsError } = useSelector(
    state => ({
      deleteManageSubsPending: state.manageSubs.deleteManageSubsPending,
      deleteManageSubsError: state.manageSubs.deleteManageSubsError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(deleteManageSubs(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissDeleteManageSubsError());
  }, [dispatch]);

  return {
    deleteManageSubs: boundAction,
    deleteManageSubsPending,
    deleteManageSubsError,
    dismissDeleteManageSubsError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_DELETE_MANAGE_SUBS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        deleteManageSubsPending: true,
        deleteManageSubsError: null,
      };

    case MANAGE_SUBS_DELETE_MANAGE_SUBS_SUCCESS:
      // The request is success
      return {
        ...state,
        deleteManageSubsPending: false,
        deleteManageSubsError: null,
      };

    case MANAGE_SUBS_DELETE_MANAGE_SUBS_FAILURE:
      // The request is failed
      return {
        ...state,
        deleteManageSubsPending: false,
        deleteManageSubsError: action.data.error,
      };

    case MANAGE_SUBS_DELETE_MANAGE_SUBS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        deleteManageSubsError: null,
      };

    default:
      return state;
  }
}
